import axios from "axios";
import { getOPCO, getSelectedLanguage } from "../helper/helper";

const configOrp = {
    baseURL:process.env.REACT_APP_BASEURL,
  }
  const apiOrp = axios.create(configOrp);
  apiOrp.defaults.headers["content-type"] = "application/json";
  apiOrp.defaults.headers["unmaskrequest"] = "enable";
  apiOrp.defaults.headers["product"] = "ORP";
  apiOrp.defaults.headers["x-app-version"] = "1.0.0";
  apiOrp.defaults.headers["Opco"] = getOPCO();
  apiOrp.defaults.headers["run-mode"] = 'beta';
  apiOrp.defaults.headers["x-service-id"] = process.env.REACT_APP_BFE_SERVICE_ID;
 
  apiOrp.interceptors.request.use(item => {
    if(item.url.includes("auth/bfe") || process.env.REACT_APP_MODE=="UAT"){
      item.headers["x-api-key"] = process.env.REACT_APP_BFE_API_KEY;
    }
    item.headers["Accept-Language"] = getSelectedLanguage()?.toLowerCase();
    return item;
  });
  
  apiOrp.interceptors.response.use(
    resp => {
      return resp;
    },
    err => {
      console.log(err)
    }
  );
export default apiOrp;
  
